export const GET_CART = "GET_CART";
export const UPDATE_CART = "UPDATE_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const INCRETE_QUANTITY = "INCRETE_QUANTITY";
export const DECRETE_QUANTITY = "DECRETE_QUANTITY";
